import { render, staticRenderFns } from "./NewsArticle.vue?vue&type=template&id=ec29cec8&scoped=true"
import script from "./NewsArticle.vue?vue&type=script&lang=js"
export * from "./NewsArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec29cec8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec29cec8')) {
      api.createRecord('ec29cec8', component.options)
    } else {
      api.reload('ec29cec8', component.options)
    }
    module.hot.accept("./NewsArticle.vue?vue&type=template&id=ec29cec8&scoped=true", function () {
      api.rerender('ec29cec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/components/NewsArticle.vue"
export default component.exports